import React from 'react';

const MvpProcess = () => {
    const processes = [
        {
            id: "01",
            step: "01. Discovery & Planning",
            title: "Defining Core Features",
            desc: "We start by understanding your business goals and target users. Together, we identify the essential features that will validate your core value proposition and create a focused development plan."
        },
        {
            id: "02",
            step: "02. Design",
            title: "User-Centric Prototyping",
            desc: "Our design team creates intuitive wireframes and prototypes focusing on key user journeys. We ensure the MVP delivers a smooth user experience while maintaining simplicity and clarity."
        },
        {
            id: "03",
            step: "03. Development",
            title: "Rapid MVP Building",
            desc: "Using agile methodologies, we quickly build your MVP with clean, scalable code. We focus on implementing core features efficiently while maintaining the flexibility for future iterations."
        },
        {
            id: "04",
            step: "04. Launch & Validate",
            title: "Testing & Feedback",
            desc: "We thoroughly test the MVP, deploy it to your target users, and help you gather valuable feedback. This data drives informed decisions about future product development."
        }
    ];

    return (
        <div className="section bg-color-light mvp-process-area" style={{paddingTop: "40px", paddingBottom: "80px"}}>
            <div className="container">
                <div className="row justify-content-center text-center">
                    <div className="col-lg-8">
                        <h2 className="title mb-3 fw-bold" style={{ fontSize: "36px" }}>
                            MVP Development <span className="text-primary">Process</span>
                        </h2>
                        <p className="subtitle mb-5 text-muted" style={{ fontSize: "16px" }}>
                            Our streamlined 4-step process helps transform your idea into a market-ready MVP that validates your business concept.
                        </p>
                    </div>
                </div>
                <div className="row g-4 pt-4">
                    {processes.map((proc) => (
                        <div className="col-lg-3 col-md-6" key={proc.id}>
                            <div className="process-card bg-white p-4 h-100 rounded position-relative overflow-hidden">
                                <h6 className="text-primary mb-3" style={{ fontSize: "13px", fontWeight: "600" }}>{proc.step}</h6>
                                <h4 className="title mb-3 fw-bold" style={{ fontSize: "18px" }}>{proc.title}</h4>
                                <p className="desc text-muted mb-0 position-relative z-index-1" style={{ fontSize: "14px", lineHeight: "1.6" }}>
                                    {proc.desc}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default MvpProcess;
